import { RouterLink } from '@angular/router';

import { FormComponent } from './app.form.component';
import { MenuItemCustom } from '../framework/MenuItemCustom.interface';
import { ChangeDetectorRef } from '@angular/core';
import { TopbarFilterController } from '../framework/filters/topbar-filter/topbar-filter-controller.interface';
import { ArrayUtil } from "src/app/core/framework/utils/array-util";

export class MenuConfig {

  private changeDetectorRef: ChangeDetectorRef;


  public showNovo = true;
  public btNovoRouterLink: RouterLink;
  public showSalvar = true;
  public showExcluir = true;
  public showVoltar = true;
  public showImprimir = false;

  public showFiltrar = false;
  private filterController: TopbarFilterController = null;

  private formComponent: FormComponent;
  private extraButtonsList: MenuItemCustom[];
  private extraWidgets: any[];

  public destroy() {
      this.formComponent = null;
      this.btNovoRouterLink = null;
      this.extraButtonsList = null;
      this.extraWidgets = null;
  }

  private changeDetector(): void {
    try {
      if ( this.changeDetectorRef ) {
        this.changeDetectorRef.detectChanges();
      }
    }
    catch(e){
      console.error(e.message);
    }
  }

  public setShowNovo(value: boolean, routerLink?: any): MenuConfig {
    this.showNovo = value;
    this.btNovoRouterLink = routerLink;
    this.changeDetector();

    return this;
  }
  public setShowSalvar(value: boolean): MenuConfig {
    this.showSalvar = value;
    this.changeDetector();

    return this;
  }
  public setShowExcluir(value: boolean): MenuConfig {
    this.showExcluir = value;
    this.changeDetector();

    return this;
  }
  public setShowVoltar(value: boolean): MenuConfig {
    this.showVoltar = value;
    this.changeDetector();

    return this;
  }
  public setShowImprimir(value: boolean): MenuConfig {
    this.showImprimir = value;
    this.changeDetector();

    return this;
  }

  public esconderFiltrar(): MenuConfig {
    this.showFiltrar = false;
    this.changeDetector();

    return this;
  }

  public exibirFiltrar<T extends TopbarFilterController>(controller: T): MenuConfig {
    if ( !controller ) {
      throw 'Controller obrigatório';
    }
    this.showFiltrar = true;
    this.filterController = controller;

    this.changeDetector();

    return this;
  }

  public setContext(value: FormComponent): MenuConfig {
    this.formComponent = value;
    this.changeDetector();

    return this;
  }

  public getContext(): FormComponent {
    return this.formComponent;
  }

  public hideAll(): MenuConfig {
    return this
        .setShowExcluir(false)
        .setShowNovo(false)
        .setShowSalvar(false)
        .setShowVoltar(false)
        .setShowImprimir(false)
        .esconderFiltrar()
        .removerExtraButtons();
  }

  public showAll(): MenuConfig {
    return this
        .setShowExcluir(true)
        .setShowNovo(true)
        .setShowSalvar(true)
        .setShowVoltar(true);
  }

  public setExtraButtons(menuItems: MenuItemCustom[]): MenuConfig {
    this.extraButtonsList = menuItems;
    this.changeDetector();

    return this;
  }

  public addExtraButtons(menuItems: MenuItemCustom[]): MenuConfig {
    if ( !menuItems ) {
      return;
    }
    if ( !this.extraButtonsList ) {
      this.extraButtonsList = [];
    }
    this.extraButtonsList = menuItems.concat(this.extraButtonsList);
    this.changeDetector();

    return this;
  }

  public removerExtraButtons(): MenuConfig {
    this.extraButtonsList = [];
    this.changeDetector();

    return this;
  }

  public removerExtraButtonPorId(id: string): void {
    const botaoARemover = this.getExtraButtonById(id);
    this.removerExtraButton(botaoARemover);
  }

  public removerExtraButton(botaoARemover: MenuItemCustom): void {
    if ( botaoARemover ) {
      ArrayUtil.removerObjetoDoArray(this.getExtraButtonList(), botaoARemover);
    }
  }

  public getExtraButtonList(): MenuItemCustom[] {
    return this.extraButtonsList;
  }

  public addExtraWidgets(widget: any): MenuConfig {
    this.extraWidgets.push(widget);
    this.changeDetector();

    return this;
  }

  public getExtraWidgets(): any[] {
    return this.extraWidgets;
  }

  public getExtraButtonById(id: string): MenuItemCustom {
    if (this.extraButtonsList) {
      for (let i = 0; i < this.extraButtonsList.length; i++) {
        if (this.extraButtonsList[i].id === id) {
          return this.extraButtonsList[i];
        }
      }
    }
    return null;
  }

  public setChangeDetectorRef(changeDetectorRef: ChangeDetectorRef): void {
    this.changeDetectorRef = changeDetectorRef;
  }

}
